/**
 * Cart Drawer Raf — open/close, Section Rendering refresh, qty, upsell, donate, carousel
 */
(function () {
  'use strict';

  var SECTION_PREFIX = 'shopify-section-';

  function normalizeSectionId(id) {
    return String(id || '').replace(new RegExp('^' + SECTION_PREFIX), '');
  }

  function buildSectionSelector(id) {
    return SECTION_PREFIX + normalizeSectionId(id);
  }

  function rootUrl() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function cartUrl(path) {
    return rootUrl().replace(/\/?$/, '/') + path.replace(/^\//, '');
  }

  async function getSectionHTML(sectionId) {
    var url = new URL(window.location.href);
    url.searchParams.set('section_id', normalizeSectionId(sectionId));
    var res = await fetch(url.toString());
    var text = await res.text();
    var doc = new DOMParser().parseFromString(text, 'text/html');
    var sectionEl = doc.getElementById(buildSectionSelector(sectionId));
    return sectionEl ? sectionEl.outerHTML : '';
  }

  function replaceDrawerContent(root, sectionId, html) {
    var target = root.querySelector('[data-cart-drawer-replace]');
    if (!target || !html) return;
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var newSection = parsed.getElementById(buildSectionSelector(sectionId));
    if (!newSection) return;
    var inner = newSection.querySelector('[data-cart-drawer-replace]');
    if (inner) {
      target.innerHTML = inner.innerHTML;
    } else {
      target.innerHTML = newSection.innerHTML;
    }
    bindInteractions(root, sectionId);
    updateHeaderBubble();
  }

  function updateHeaderBubble() {
    fetch(cartUrl('cart.js'), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = (cart && cart.item_count) || 0;
        var bubbles = document.querySelectorAll('.cart-link__bubble');
        bubbles.forEach(function (el) {
          el.classList.toggle('cart-link__bubble--visible', count > 0);
        });
        document.querySelectorAll('.cart-link__bubble-num').forEach(function (el) {
          el.textContent = String(count);
        });
        document.dispatchEvent(new CustomEvent('cart-drawer:loaded', { detail: { cart: cart } }));
      })
      .catch(function () {});
  }

  function lockScroll(on) {
    if (on) {
      var y = window.scrollY;
      document.body.style.setProperty('position', 'fixed');
      document.body.style.setProperty('top', '-' + y + 'px');
      document.body.style.setProperty('width', '100%');
      document.body.dataset.cdrScrollY = String(y);
    } else {
      var y2 = parseInt(document.body.dataset.cdrScrollY || '0', 10) || 0;
      document.body.style.removeProperty('position');
      document.body.style.removeProperty('top');
      document.body.style.removeProperty('width');
      delete document.body.dataset.cdrScrollY;
      window.scrollTo(0, y2);
    }
  }

  async function openAndRefresh(root, sectionId, sectionsFromEvent) {
    var dialog = root.querySelector('dialog');
    if (!dialog) return;
    if (!dialog.open) {
      lockScroll(true);
      dialog.showModal();
    }
    root.classList.remove('cdr--empty');
    var html =
      sectionsFromEvent && sectionsFromEvent[normalizeSectionId(sectionId)]
        ? sectionsFromEvent[normalizeSectionId(sectionId)]
        : sectionsFromEvent && sectionsFromEvent[sectionId]
          ? sectionsFromEvent[sectionId]
          : await getSectionHTML(sectionId).catch(function () { return ''; });
    if (html) replaceDrawerContent(root, sectionId, html);
    else bindInteractions(root, sectionId);
  }

  function closeDrawer(root) {
    var dialog = root.querySelector('dialog');
    if (!dialog || !dialog.open) return;
    dialog.close();
    lockScroll(false);
  }

  function changeLine(root, sectionId, line, quantity) {
    return fetch(cartUrl('cart/change.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('change failed');
        return r.json();
      })
      .then(function () {
        return openAndRefresh(root, sectionId, null);
      });
  }

  function addVariant(root, sectionId, variantId, btn) {
    if (btn) btn.classList.add('is-loading');
    return fetch(cartUrl('cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        return openAndRefresh(root, sectionId, null);
      })
      .finally(function () {
        if (btn) btn.classList.remove('is-loading');
      });
  }

  function initUpsellCarousel(root) {
    var wrap = root.querySelector('[data-cdr-upsell]');
    if (!wrap || wrap.getAttribute('data-cdr-upsell-ready')) return;
    wrap.setAttribute('data-cdr-upsell-ready', 'true');
    var track = wrap.querySelector('[data-cdr-upsell-track]');
    var dotsWrap = wrap.querySelector('[data-cdr-upsell-dots]');
    var prev = wrap.querySelector('[data-cdr-upsell-prev]');
    var next = wrap.querySelector('[data-cdr-upsell-next]');
    if (!track) return;
    var cards = track.querySelectorAll('[data-cdr-upsell-card]');
    if (dotsWrap && cards.length) {
      dotsWrap.innerHTML = '';
      for (var i = 0; i < cards.length; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'cdr-upsell__dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('data-index', String(i));
        dotsWrap.appendChild(dot);
      }
    }
    function cardWidth() {
      var c = track.querySelector('[data-cdr-upsell-card]');
      if (!c) return 200;
      return c.getBoundingClientRect().width + 12;
    }
    function updateDots() {
      if (!dotsWrap) return;
      var idx = Math.round(track.scrollLeft / cardWidth());
      dotsWrap.querySelectorAll('.cdr-upsell__dot').forEach(function (d, i) {
        d.classList.toggle('is-active', i === idx);
      });
    }
    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -cardWidth(), behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: cardWidth(), behavior: 'smooth' });
      });
    }
    if (dotsWrap) {
      dotsWrap.addEventListener('click', function (e) {
        var d = e.target.closest('.cdr-upsell__dot');
        if (!d) return;
        var i = parseInt(d.getAttribute('data-index') || '0', 10);
        track.scrollTo({ left: i * cardWidth(), behavior: 'smooth' });
      });
    }
    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(updateDots);
    }, { passive: true });
  }

  function bindDonate(root, sectionId) {
    var box = root.querySelector('[data-cdr-donate]');
    if (!box || box.getAttribute('data-cdr-donate-bound')) return;
    box.setAttribute('data-cdr-donate-bound', 'true');
    var cta = box.querySelector('[data-cdr-donate-submit]');
    var amounts = box.querySelectorAll('[data-cdr-donate-amount]');

    function setActive(btn) {
      amounts.forEach(function (b) {
        var on = b === btn;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (cta) {
        var id = btn.getAttribute('data-variant-id');
        var label = btn.getAttribute('data-label') || '';
        var tmpl = cta.getAttribute('data-label-template') || 'DONATE [amount]';
        cta.setAttribute('data-variant-id', id);
        cta.textContent = tmpl.replace('[amount]', label);
      }
    }

    amounts.forEach(function (btn) {
      btn.addEventListener('click', function () { setActive(btn); });
    });

    if (cta) {
      cta.addEventListener('click', function () {
        var id = cta.getAttribute('data-variant-id');
        if (!id) return;
        addVariant(root, sectionId, id, cta);
      });
    }
  }

  function bindInteractions(root, sectionId) {
    root.querySelectorAll('[data-cdr-close]').forEach(function (btn) {
      if (btn.getAttribute('data-cdr-bound')) return;
      btn.setAttribute('data-cdr-bound', 'true');
      btn.addEventListener('click', function () { closeDrawer(root); });
    });

    root.querySelectorAll('[data-cdr-qty-minus]').forEach(function (btn) {
      if (btn.getAttribute('data-cdr-bound')) return;
      btn.setAttribute('data-cdr-bound', 'true');
      btn.addEventListener('click', function () {
        var line = parseInt(btn.getAttribute('data-line') || '0', 10);
        var qty = parseInt(btn.getAttribute('data-qty') || '1', 10) - 1;
        if (line < 1) return;
        changeLine(root, sectionId, line, Math.max(0, qty));
      });
    });

    root.querySelectorAll('[data-cdr-qty-plus]').forEach(function (btn) {
      if (btn.getAttribute('data-cdr-bound')) return;
      btn.setAttribute('data-cdr-bound', 'true');
      btn.addEventListener('click', function () {
        var line = parseInt(btn.getAttribute('data-line') || '0', 10);
        var qty = parseInt(btn.getAttribute('data-qty') || '1', 10) + 1;
        if (line < 1) return;
        changeLine(root, sectionId, line, qty);
      });
    });

    root.querySelectorAll('[data-cdr-remove]').forEach(function (btn) {
      if (btn.getAttribute('data-cdr-bound')) return;
      btn.setAttribute('data-cdr-bound', 'true');
      btn.addEventListener('click', function () {
        var line = parseInt(btn.getAttribute('data-line') || '0', 10);
        if (line < 1) return;
        changeLine(root, sectionId, line, 0);
      });
    });

    root.querySelectorAll('[data-cdr-add]').forEach(function (btn) {
      if (btn.getAttribute('data-cdr-bound')) return;
      btn.setAttribute('data-cdr-bound', 'true');
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-variant-id');
        if (!id) return;
        addVariant(root, sectionId, id, btn);
      });
    });

    bindDonate(root, sectionId);
    initUpsellCarousel(root);
  }

  function init() {
    var root = document.querySelector('[data-cart-drawer-raf]');
    if (!root || root.getAttribute('data-cdr-ready')) return;
    root.setAttribute('data-cdr-ready', 'true');

    var sectionId = root.getAttribute('data-section-id');
    if (!sectionId) return;

    var dialog = root.querySelector('dialog');
    if (!dialog) return;

    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) closeDrawer(root);
    });
    dialog.addEventListener('cancel', function (e) {
      e.preventDefault();
      closeDrawer(root);
    });

    document.addEventListener('cart-drawer:open', function (e) {
      openAndRefresh(root, sectionId, e.detail && e.detail.sections ? e.detail.sections : null);
    });

    document.addEventListener('cart:update', function (e) {
      var sections = e.detail && e.detail.sections;
      if (sections && (sections[sectionId] || sections[normalizeSectionId(sectionId)])) {
        replaceDrawerContent(
          root,
          sectionId,
          sections[sectionId] || sections[normalizeSectionId(sectionId)]
        );
      } else {
        getSectionHTML(sectionId).then(function (html) {
          if (html) replaceDrawerContent(root, sectionId, html);
        });
      }
    });

    document.addEventListener('bundle:cart-added', function (e) {
      openAndRefresh(root, sectionId, e.detail && e.detail.sections ? e.detail.sections : null);
    });

    // Header bag: intercept Impulse cart opener
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('.js-drawer-open-cart, [data-cdr-open], [aria-controls="CartDrawer"]');
      if (!opener) return;
      if (opener.closest('[data-cart-drawer-raf]')) return;
      e.preventDefault();
      openAndRefresh(root, sectionId, null);
    });

    bindInteractions(root, sectionId);

    window.CartDrawerRaf = {
      open: function () { openAndRefresh(root, sectionId, null); },
      close: function () { closeDrawer(root); }
    };

    // When Impulse theme opens its hidden drawer after ATC, open ours instead
    document.addEventListener('ajaxProduct:added', function () {
      window.setTimeout(function () {
        document.documentElement.classList.remove('js-drawer-open', 'js-drawer-open--cart');
        document.body.classList.remove('js-drawer-open');
        openAndRefresh(root, sectionId, null);
      }, 10);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (!e || !e.target) return;
    if (e.target.querySelector('[data-cart-drawer-raf]') || e.target.hasAttribute('data-cart-drawer-raf')) {
      var el = e.target.hasAttribute('data-cart-drawer-raf') ? e.target : e.target.querySelector('[data-cart-drawer-raf]');
      if (el) el.removeAttribute('data-cdr-ready');
      init();
    }
  });
})();
